import {AxiosResponse} from "axios";
import {Language, SharePayloadType, TeamRegion} from "data/enums";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IApiResponse, IHttpClientService} from "data/services/http";

export interface ITeamResponse {
	id: number | null;
	team: string;
	lineup: number[] | null;
	userId: number;
}

export interface ICreateTeamPayload {
	lang: Language;
	lineup: number[];
	team: TeamRegion;
}

export interface IShareTeamPayload {
	lang: Language;
	type: SharePayloadType;
}

export type TTeamResponse = IApiResponse<{team: ITeamResponse}>;
export type TShareResponse = IApiResponse<{link: string; preview: string}>;

export interface ITeamApiProvider {
	create: (params: ICreateTeamPayload) => Promise<AxiosResponse<TTeamResponse>>;
	share: (params: IShareTeamPayload) => Promise<AxiosResponse<TShareResponse>>;
}

@injectable()
export class TeamApiProvider implements ITeamApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	create = ({lang, ...params}: ICreateTeamPayload) =>
		this._http.post<TTeamResponse>(`${lang}/pickem/team`, params);
	share = ({lang, ...params}: IShareTeamPayload) =>
		this._http.get<TShareResponse>(`${lang}/pickem/team/share`, params);
}
